import { css } from '@emotion/react';
import { FlexStyle } from './FlexStyles';
import { PaddingStyle } from './PaddingStyle';
import { themeOld } from './theme';

export const ButtonStyle = (
	{
		primary,
		danger,
		outline,
		block,
		sizeLarge,
		sizeMedium,
		sizeSmall,
		sizeExtraLarge,
	}: {
		primary?: boolean;
		danger?: boolean;
		outline?: boolean;
		block?: boolean;
		sizeSmall?: boolean;
		sizeMedium?: boolean;
		sizeLarge?: boolean;
		sizeExtraLarge?: boolean;
	} = {
		primary: false,
		danger: false,
		outline: false,
		block: false,
		sizeLarge: false,
		sizeMedium: false,
		sizeSmall: false,
		sizeExtraLarge: false,
	},
) => [
	FlexStyle({ centered: true }),
	PaddingStyle({ h: 16, v: 8 }),
	css`
		border-radius: 4px;

		height: 40px;

		line-height: 20px;

		background: #fff;
		color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_23};
		border: 1px solid #fff;
		font-size: 14px;
		font-weight: 500;

		${block &&
		css`
			width: 100%;
		`}

		&, &:hover, &:focus, &:active {
			transition: all 0.2s ease-in-out;
			outline: none;
		}

		&:hover {
			background: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_74};
			border-color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_74};
			cursor: pointer;
			text-decoration: none;
		}

		&:active {
			background: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_74};
			border-color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_74};
			color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_40};
		}

		// Sizes

		${sizeSmall &&
		css`
			height: 32px;
			font-size: 13px;
		`};

		${sizeMedium &&
		css`
			height: 36px;
		`}

		${sizeLarge &&
		css`
			height: 48px;
		`};

		${sizeExtraLarge &&
		css`
			height: 56px;
		`};

		${outline &&
		css`
			border: 1px solid ${themeOld.COLOR_DARK_GREEN_LIGHTEN_65};

			&:hover {
				border-color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_65};
				color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_23};
			}

			&:active {
				border-color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_65};
				color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_40};
			}
		`};

		// Primary
		${primary &&
		css`
			border: 1px solid ${themeOld.COLOR_BASE_GREEN};
			background: ${themeOld.COLOR_BASE_GREEN};
			color: #fff;

			&:hover,
			&:focus {
				border-color: ${themeOld.COLOR_GREEN_LIGHTEN_2};
				background: ${themeOld.COLOR_GREEN_LIGHTEN_2};
				color: #fff;
			}

			/*TODO - Disable by mel byt spis diabled.processing */
			&:active,
			&:disabled {
				background: ${themeOld.COLOR_GREEN_DARKEN_6};
				border-color: ${themeOld.COLOR_GREEN_DARKEN_6};
				color: #fff;
				cursor: default;
			}
		`}

		${danger &&
		css`
			border: 1px solid ${themeOld.COLOR_BASE_RED};
			background: ${themeOld.COLOR_BASE_RED};
			color: #fff;

			&:hover,
			&:focus {
				border: 1px solid #ff6666;
				background: #ff6666;
				color: #fff;
			}

			&:active {
				border: 1px solid #ff3333;
				background: #ff3333;
				color: #fff;
			}
		`};
	`,
];
